import axios from "axios";
import authHeader from "./authHeader";
import * as moment from "moment";
import store from "../Redux/store";
import { useSelector } from "react-redux";
import { OrderStatus } from "../data/enums";
import { buildURLQueryNoNulls } from "../utils";

const API_URL = process.env.REACT_APP_API_URL;
const PCI_API_URL = process.env.REACT_APP_PCI_API_URL;

const getCities = (chainId) => {
  let res = axios.get(
    `${API_URL}oms/cities?chainId=${chainId}&includeTranslations=true`,
    { headers: authHeader() }
  );
  return res;
};

const getProperties = (chainId) => {
  let res = axios.get(
    `${API_URL}oms/properties?chainidlistcsv=${chainId}&includeTranslations=true`,
    { headers: authHeader() }
  );
  return res;
};

const getProducts = (chainId, propertyId, includeTranslations, productId) => {
  let company = sessionStorage.getItem("company")
    ? JSON.parse(sessionStorage.getItem("company"))
    : null;
  if (productId && productId > 0) {
    let res;
    if (company) {
      res = axios.get(
        `${API_URL}ishop/company-products/${company.companyId}?includeDiscounts=true&productIdsCSV=${productId}&includeTranslations=true&includeImages=true`,
        { headers: authHeader() }
      );
    } else {
      res = axios.get(
        `${API_URL}ishop/products?chainId=${chainId}&includeTranslations=${includeTranslations}&productId=${productId}&isActive=true&isForAdminUI=false&includeCategories=true`,
        { headers: authHeader() }
      );
    }
    return res;
  } else {
    let res = axios.get(
      API_URL +
        "ishop/products?chainId=" +
        chainId +
        (propertyId ? "&propertyId=" + propertyId : "") +
        "&includeTranslations=" +
        includeTranslations +
        "&isActive=true&isForAdminUI=false" +
        "&includeCategories=true",
      { headers: authHeader() }
    );
    return res;
  }
};

const getCustomer = (email) => {
  if (email) {
    let res = axios.get(`${API_URL}ishop/customers?customerEmail=${email}`, {
      headers: authHeader(),
    });
    return res;
  }
};

const insertSearch = (
  myproductId,
  mysearchId,
  myorderId,
  mycustomerId,
  isapplyNulls,
  mysearchTime
) => {
  sessionStorage.removeItem("productLastSearchId");
  let data = {
    searchId: mysearchId,
    productId: myproductId,
    searchTime: mysearchTime,
    customerId: mycustomerId,
    orderId: myorderId,
    applyNulls: isapplyNulls,
  };
  axios
    .post(`${API_URL}ishop/search`, data, { headers: authHeader() })
    .then((response) => {
      if (!response.data.HasErrors) {
        // handle success
        window.sessionStorage.setItem(
          "productLastSearchId",
          response.data.data
        );
      } else {
        console.log(response.data.errors[0].message);
      }
    })
    .catch((err) => {
      // handle error
      console.error(err.message);
    });
};

const setOrder = (
  chainId,
  myproducts,
  customer,
  myGifteeDtls,
  languageIsoCode,
  customerIp,
  customerBrowserAgent,
  gifteeMsg,
  payerName,
  payerCompID,
  orderStatusId,
  sendToGifteeTime,
  blockingIdentifier
) => {
  if (!Object.keys(myGifteeDtls).length) {
    myGifteeDtls = {
      GiftEmailInput: customer.customerEmail,
      GiftfullNameInput:
        customer.customerFirstName + " " + customer.customerLastName,
      GifteePhoneInput: customer.customerPhone,
    };
  }

  return new Promise((resolve, reject) => {
    let data = {
      orderId: null,
      chainId: chainId,
      propertyId: null,
      ordersStatusId: orderStatusId ? orderStatusId : OrderStatus.InProcess,
      products: Object.keys(myproducts).map((k) => {
        const currentItem = myproducts[k];
        const currentProduct = currentItem.selectedProduct;
        return {
          orderId: 0,
          productId: currentProduct.productId,
          productTypeId: currentProduct.productTypeId,
          quantity: currentItem.qty,
          price: currentProduct.productPrice * currentItem.qty,
          currencyCode: currentProduct.currencyCode,
          orderActiveDateStart: currentProduct.saleStartDate,
          orderActiveDateEnd: currentProduct.saleEndDate,
          duration: currentProduct.duration,
          orderDates: [moment(new Date()).format("YYYY-MM-DD")],
          productBlockingIdentifier: blockingIdentifier,
        };
      }),
      customerIp: customerIp,
      isDeleted: false,
      message: gifteeMsg,
      customer: customer,
      payments: null,
      sendToGiftee:
        myGifteeDtls && myGifteeDtls.GiftfullNameInput ? true : false,
      gifteeEmail:
        myGifteeDtls && myGifteeDtls.GiftEmailInput
          ? myGifteeDtls.GiftEmailInput
          : "",
      gifteeName:
        myGifteeDtls && myGifteeDtls.GiftfullNameInput
          ? myGifteeDtls.GiftfullNameInput
          : "",
      gifteePhone:
        myGifteeDtls && myGifteeDtls.GifteePhoneInput
          ? myGifteeDtls.GifteePhoneInput
          : "",
      languageIsoCode: languageIsoCode,
      agreeToTerms: true,
      agreeToTermsOn: moment(new Date()).format("YYYY-MM-DDThh:mm:ss"),
      customerIp: customerIp,
      customerBrowserAgent: customerBrowserAgent,
      sendToGifteeTime: sendToGifteeTime,
    };

    sessionStorage.removeItem("lastOrderNum");
    sessionStorage.removeItem("lastCustomer");
    sessionStorage.removeItem("completedOrder");
    sessionStorage.removeItem("payerName");
    sessionStorage.removeItem("payerCompID");

    axios
      .post(`${API_URL}ishop/order`, data, { headers: authHeader() })
      .then((response) => {
        if (!response.data.HasErrors) {
          // handle success
          sessionStorage.setItem("lastOrderNum", response.data.data.orderId);

          if (payerName && payerName.length) {
            sessionStorage.setItem("payerName", payerName);
          }
          if (payerCompID && payerCompID.length) {
            sessionStorage.setItem("payerCompID", payerCompID);
          }

          sessionStorage.setItem("lastCustomer", JSON.stringify(customer));
          resolve(true);
        } else {
          reject(response.data.errors[0].Message);
          alert(response.data.errors[0].Message);
        }
      })
      .catch((err) => {
        // handle error
        console.error(err.message);
        reject(err);
      });
  });
};

const updateOrders = (chainId, groupOrderId, myordersStatusId, myPayments) => {
  return new Promise((resolve, reject) => {
    let data = {
      groupOrderId: groupOrderId,
      chainId: chainId,
      ordersStatusId: myordersStatusId,
      payments: myPayments,
    };

    axios
      .post(`${API_URL}ishop/orders`, data, { headers: authHeader() })
      .then((response) => {
        if (!response.data.HasErrors) {
          // handle success
          resolve(true);
        } else {
          reject(response.data.errors[0].message);
          alert(response.data.errors);
        }
      })
      .catch((err) => {
        // handle error
        console.error(err.message);
        reject(err);
      });
  });
};

const updateOrder = (
  chainId,
  myorderId,
  myordersStatusId,
  myPayments,
  searchesIds,
  updateCustomer,
  propertyId
) => {
  return new Promise((resolve, reject) => {
    let data = {
      orderId: myorderId,
      chainId: chainId,
      ordersStatusId: myordersStatusId,
      payments: myPayments,
      searches: searchesIds,
      customer: updateCustomer,
      propertyId: propertyId,
    };

    axios
      .post(`${API_URL}ishop/order`, data, { headers: authHeader() })
      .then((response) => {
        if (!response.data.HasErrors) {
          // handle success
          resolve(true);
        } else {
          reject(response.data.errors[0].message);
          alert(response.data.errors);
        }
      })
      .catch((err) => {
        // handle error
        console.error(err.message);
        reject(err);
      });
  });
};

const getPCIframe = (
  chainId,
  lang,
  propertyId,
  bookingID,
  payBY,
  payerCompID,
  isGroupId
) => {
  let res;
  if (payBY && payBY !== "") {
    res = axios.get(
      `${PCI_API_URL}pci/products/payment-url/${chainId}/${lang}/${bookingID}/${propertyId}/${true}/${payBY}/${payerCompID}/${isGroupId}`,
      { headers: authHeader() }
    );
  } else {
    res = axios.get(
      `${PCI_API_URL}pci/products/payment-url/${chainId}/${lang}/${bookingID}/${propertyId}/${isGroupId}`,
      { headers: authHeader() }
    );
  }
  return res;
};

const getChains = (chainId) => {
  let res = axios.get(
    `${API_URL}oms/chains?chainId=${chainId}&includeProperties=true&includeTranslations=true`,
    { headers: authHeader() }
  );
  return res;
};

const getGlobalParameters = (paramName) => {
  let res = axios.get(
    `${API_URL}system/global/parameters?globalParameterName=${paramName}&includeTranslations=true`,
    { headers: authHeader() }
  );
  return res;
};

const getOrders = (ordersRequest) => {
  let res = axios.get(
    `${API_URL}ishop/orders?${buildURLQueryNoNulls(ordersRequest)}`,
    { headers: authHeader() }
  );
  return res;
};

const getCustomerRequests = (customerId, chainId) => {
  let res = axios.get(
    `${API_URL}system/global/customer-requests?customerId=${customerId}&chainId=${chainId}`,
    { headers: authHeader() }
  );
  return res;
};

const sendIdentityVerificationSms = (myemail, mypropertyId, mychainId) => {
  return new Promise((resolve, reject) => {
    let data = {
      email: myemail,
    };
    axios
      .post(
        `${API_URL}ishop/customer-send-identity-verification-sms?email=${myemail}&propertyId=${mypropertyId}&chainId=${mychainId}`,
        null,
        { headers: authHeader() }
      )
      .then((response) => {
        if (!response.data.HasErrors) {
          // handle success
          resolve(response.data.data);
        } else {
          reject(response.data.errors[0].message);
          alert(response.data.errors);
        }
      })
      .catch((err) => {
        // handle error
        console.error(err.message);
        reject(err);
      });
  });
};

const verifyIdentityBySms = (myemail, mysmscode) => {
  return new Promise((resolve, reject) => {
    let data = {
      email: myemail,
      smscode: mysmscode,
    };
    axios
      .post(
        `${API_URL}ishop/customer-verify-identity?email=${myemail}&smscode=${mysmscode}`,
        data,
        { headers: authHeader() }
      )
      .then((response) => {
        if (!response.data.HasErrors) {
          // handle success
          resolve(response.data.data);
        } else {
          reject(response.data.errors[0].message);
        }
      })
      .catch((err) => {
        // handle error
        console.error(err.message);
        reject(err);
      });
  });
};

const updateCustomer = (customerId, fullname, email, phone) => {
  return new Promise((resolve, reject) => {
    let data = {
      customerId: customerId,
      customerFirstName: fullname.substring(0, fullname.indexOf(" ")),
      customerLastName: fullname.substring(fullname.indexOf(" ") + 1),
      customerEmail: email,
      customerPhone: phone,
    };
    axios
      .post(`${API_URL}ishop/customer`, data, { headers: authHeader() })
      .then((response) => {
        if (!response.data.HasErrors) {
          // handle success
          resolve(true);
        } else {
          reject(response.data.errors[0].message);
          alert(response.data.errors);
        }
      })
      .catch((err) => {
        // handle error
        console.error(err.message);
        reject(err);
      });
  });
};

const blockProduct = (myproductId, quantityToBlock) => {
  return new Promise((resolve, reject) => {
    sessionStorage.removeItem("productLastSearchId");
    let data = {
      productId: myproductId,
      quantity: quantityToBlock,
      startDate: null,
      endDate: null,
    };
    axios
      .post(`${API_URL}ishop/blocking`, data, { headers: authHeader() })
      .then((response) => {
        if (!response.data.HasErrors) {
          // handle success
          resolve(response.data);
        } else {
          reject(response.data.errors[0].message);
        }
      })
      .catch((err) => {
        // handle error
        console.error(err.message);
      });
  });
};

const unblockProduct = (productBlockingIdentifier) => {
  return new Promise((resolve, reject) => {
    sessionStorage.removeItem("productLastSearchId");
    axios
      .delete(`${API_URL}ishop/blocking/${productBlockingIdentifier}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (!response.data.HasErrors) {
          // handle success
          resolve(response.data);
        } else {
          reject(response.data.errors[0].message);
        }
      })
      .catch((err) => {
        // handle error
        console.error(err.message);
      });
  });
};

const getUserIp = async () => {
  const res = await axios.get("https://geolocation-db.com/json/");

  return res.data.IPv4;
};

const insertContactFormReq = (
  myrequestorFullName,
  myrequestorPhone,
  myrequestorEmail,
  myrequestContent,
  mychainId,
  customerID,
  customerPassport = null
) => {
  return new Promise((resolve, reject) => {
    let data = {
      requestorFullName: myrequestorFullName,
      requestorPhone: myrequestorPhone,
      requestorEmail: myrequestorEmail,
      requestContent: myrequestContent,
      resolutionContent: "",
      chainId: mychainId,
      customerId: customerID,
      customerIdentification: customerPassport,
    };

    axios
      .post(`${API_URL}system/global/customer-request`, data, {
        headers: authHeader(),
      })
      .then((response) => {
        if (!response.data.HasErrors) {
          // handle success
          resolve(response.data);
        } else {
          reject(response.data.errors[0].message);
        }
      })
      .catch((err) => {
        // handle error
        console.error(err.message);
      });
  });
};

const getVoucher = (vouchertoken) => {
  let res = axios.get(`${API_URL}files/download/${vouchertoken}`, {
    headers: authHeader(),
    responseType: "blob",
  });
  return res;
};

const getOrderRedeemItems = (chainId, orderId, productId) => {
  let res = axios.get(
    `${API_URL}ishop/orders-products-redeem-items?chainId=${chainId}&orderId=${orderId}&productId=${productId}`,
    { headers: authHeader() }
  );
  return res;
};

const getPropertyById = (chainId, propertyId) => {
  let res = axios.get(
    `${API_URL}oms/properties/${propertyId}?chainidlistcsv=${chainId}&includeTranslations=true`,
    { headers: authHeader() }
  );
  return res;
};

const getCategoryTranslations = (chainId) => {
  let res = axios.get(
    `${API_URL}ishop/categories-translations?chainId=${chainId}`,
    { headers: authHeader() }
  );
  return res;
};

const getCategories = (chainId) => {
  let res = axios.get(
    `${API_URL}ishop/categories?chainId=${chainId}&includeTranslations=true`,
    { headers: authHeader() }
  );
  return res;
};
const login = (user) => {
  let res = axios.post(`${API_URL}/users/login`, user, {
    headers: authHeader(),
  });
  return res;
};
const logout = () => {
  let res = axios.get(`${API_URL}/users/logout`, { headers: authHeader() });
  return res;
};

const getCompanyProducts = (companyId, productIdsCSV) => {
  let url = `${API_URL}ishop/company-products/${companyId}?includeDiscounts=true&includeTranslations=true&includeImages=true`;
  if (typeof productIdsCSV === "string" && productIdsCSV !== "") {
    url += `&productIdsCSV=${productIdsCSV}`;
  }
  let res = axios.get(url, { headers: authHeader() });
  return res;
};

const getCompanyWorkers = (companyId) => {
  let res = axios.get(`${API_URL}/ishop/company-workers/${companyId}`, {
    headers: authHeader(),
  });
  return res;
};
const getCompanyMops = (companyId) => {
  let res = axios.get(`${API_URL}/ishop/company-mops/${companyId}`, {
    headers: authHeader(),
  });
  return res;
};
const getCompany = (companyId) => {
  let res = axios.get(`${API_URL}/ishop/companies?companyId=${companyId}`, {
    headers: authHeader(),
  });
  return res;
};
const confirmCode = (userId, code) => {
  let res = axios.get(`${API_URL}/users/confirmsms/${userId}/${code}`, {
    headers: authHeader(),
  });
  return res;
};

const setOrders = (
  chainId,
  productId,
  quantity,
  gifteeMsg,
  languageIsoCode,
  customerIp,
  customerBrowserAgent,
  orderStatusId,
  giftees,
  sendToGifteeTime,
  companyId,
  customerId
) => {
  return new Promise((resolve, reject) => {
    let data = {
      chainId: chainId,
      propertyId: 0,
      companyId: companyId,
      ordersStatusId: orderStatusId ? orderStatusId : OrderStatus.InProcess,
      customerIp: customerIp,
      message: gifteeMsg,
      customerId: customerId,
      productId: productId,
      payments: null,
      languageIsoCode: languageIsoCode,
      customerIp: customerIp,
      customerBrowserAgent: customerBrowserAgent,
      quantity,
      giftees: giftees,
      sendToGifteeTime: sendToGifteeTime,
    };

    sessionStorage.removeItem("lastOrderNum");
    sessionStorage.removeItem("lastCustomer");
    sessionStorage.removeItem("completedOrder");
    sessionStorage.removeItem("payerName");
    sessionStorage.removeItem("payerCompID");

    axios
      .post(`${API_URL}ishop/orders`, data, { headers: authHeader() })
      .then((response) => {
        if (!response.data.HasErrors) {
          // handle success
          if (!response.data.HasErrors) {
            resolve(response);
          } else {
            reject(response.data.errors[0].message);
            alert(response.data.errors);
          }
          resolve(true);
        } else {
          reject(response.data.errors[0].message);
          alert(response.data.errors);
        }
      })
      .catch((err) => {
        // handle error
        console.error(err.message);
        reject(err);
      });
  });
};
const getCompanyOrders = (groupOrderId) => {
  let res = axios.get(`${API_URL}/ishop/orders?groupOrderId=${groupOrderId}`, {
    headers: authHeader(),
  });
  return res;
};

const updateUserDetails = (user) => {
  return axios.post(`${API_URL}/users/createorupdate`, user, {
    headers: authHeader(),
  });
};

const setCustomer = (customer) => {
  return axios.post(`${API_URL}/ishop/customer`, customer, {
    headers: authHeader(),
  });
};
const getBlockedProduct = (productId, blockingIdentifier) => {
  let res = axios.get(
    `${API_URL}/ishop/blocking?productId=${productId}&identifier=${blockingIdentifier}`,
    { headers: authHeader() }
  );
  return res;
};

export default {
  setCustomer,
  updateUserDetails,
  getCompanyOrders,
  getCompanyMops,
  getCompany,
  getCategories,
  getCategoryTranslations,
  getCompanyWorkers,
  getCities,
  getProducts,
  getProperties,
  setOrder,
  setOrders,
  getPCIframe,
  insertSearch,
  updateOrder,
  updateOrders,
  getCustomer,
  getChains,
  getGlobalParameters,
  // getOrder,
  sendIdentityVerificationSms,
  verifyIdentityBySms,
  getOrders,
  updateCustomer,
  blockProduct,
  unblockProduct,
  getUserIp,
  insertContactFormReq,
  getCustomerRequests,
  getVoucher,
  getOrderRedeemItems,
  getPropertyById,
  login,
  logout,
  getCompanyProducts,
  confirmCode,
  getBlockedProduct,
};
